import { AppTabTrigger } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { ChevronDown, ChevronUp } from 'lucide-react'
import type React from 'react'
import { useRef } from 'react'

interface CollapsibleTabTriggerProps {
  /** タブの値 */
  value: string
  /** 現在のタブ */
  currentTab: string
  /** ヘッダーが開いているか */
  isHeaderOpen: boolean
  /** ヘッダーの開閉状態を切り替える */
  onToggleHeader: () => void
  /** タブのラベル */
  children: React.ReactNode
}

export function CollapsibleTabTrigger({
  value,
  currentTab,
  isHeaderOpen,
  onToggleHeader,
  children,
}: CollapsibleTabTriggerProps) {
  const isActive = currentTab === value
  // mousedown時点でのアクティブ状態を保存（Radixがタブを切り替える前の状態）
  const wasActiveOnMouseDownRef = useRef(false)

  const handleMouseDown = () => {
    // クリック開始時点でのアクティブ状態を記録
    wasActiveOnMouseDownRef.current = isActive
  }

  const handleClick = (e: React.MouseEvent) => {
    // mousedown時点で既にアクティブだった場合のみトグル
    if (wasActiveOnMouseDownRef.current) {
      e.preventDefault()
      onToggleHeader()
    }
  }

  return (
    <AppTabTrigger value={value} onMouseDown={handleMouseDown} onClick={handleClick}>
      <span className='flex items-center gap-1'>
        {children}
        {/* アイコンのスペースを常に確保してレイアウトシフトを防ぐ */}
        {/* 開いている時はChevronDown、閉じている時はChevronUp（AppSectionTitleと統一） */}
        <span className={isActive ? 'visible' : 'invisible'}>
          {isHeaderOpen ? <ChevronDown className='h-3.5 w-3.5' /> : <ChevronUp className='h-3.5 w-3.5' />}
        </span>
      </span>
    </AppTabTrigger>
  )
}
